import React from "react";
import { Card, Grid } from "@mui/material";
import Title from "./../ReusableComponents/title";
import ResultByCloseChart from "../Charts/ResultByClose";
import ResultByOpenChart from "../Charts/ResultByOpen";
import ResultbyDaysTable from "./ResultByDaysTable";

const ResultbyDays = ({ data }) => {
  console.log("ResultByCloseChart Data:", data);

  return (
    <Grid sx={{ marginTop: "0px" }} container spacing={3}>
      <Grid container item xs={12} spacing={3} sx={{ paddingTop: "0px" }}>
        <Grid className='result-days' item xs={12} lg={6}>
          <Card className="card-csc" sx={{marginLeft:'15px'}}>
            <Title six>Results by close</Title>
            <ResultByCloseChart data={data} />
          </Card>
        </Grid>
        <Grid item xs={12} lg={6}>
          <Card className="card-csc">
            <Title six>Results by Open</Title>
            <ResultByOpenChart data={data} />
          </Card>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Card className="card-csc" sx={{marginLeft:'15px'}}>
          <Title six>Results by Days</Title>
          <ResultbyDaysTable data={data} />
        </Card>
      </Grid>
    </Grid>
  );
};

export default ResultbyDays;
